import { PublicClientApplication } from "@azure/msal-browser";

export const msalConfig = {
    auth: {
        clientId: "3aa646fc-ce74-4804-80b7-a0d9214fbc54",
        authority: "https://login.microsoftonline.com/common",
        redirectUri: "https://getvizedi.com/"
    },
    cache: {
        cacheLocation: "localStorage",
        storeAuthStateInCookie: true
    }
};

export const msalInstance = new PublicClientApplication(msalConfig);